import View from '@shared/components/layout-default/layout-default-router-view';
import OperatorView from '@pbx/pages/operators';

export const contacts = [
  {
    path: 'contacts',
    component: OperatorView,
    children: [
      {
        path: '',
        name: 'pbx.contact.index',
        component: () =>
          import(/* webpackChunkName: 'pbx-contacts' */ '@pbx/pages/operators/contacts'),
        meta: {
          title: {
            code: 'pbx.breadcrumb.contact.index'
          }
        }
      }
    ]
  },

  {
    path: 'contacts',
    component: View,
    children: [
      {
        path: 'new',
        name: 'pbx.contact.create',
        component: () =>
          import(
            /* webpackChunkName: 'pbx-contacts' */
            '@pbx/pages/operators/contacts/create'
          ),
        meta: {
          title: { code: 'pbx.breadcrumb.contact.create' }
        }
      },

      {
        path: ':id([\\d]*)',
        name: 'pbx.contact.edit',
        component: () =>
          import(
            /* webpackChunkName: 'pbx-contacts' */
            '@pbx/pages/operators/contacts/edit'
          ),
        meta: {
          title: {
            code: 'pbx.breadcrumb.contact.edit'
          },
          loadable: true
        }
      }
    ]
  }
];
